/*
 *
 * projectAPI.js
 *
 */

import Axios from "axios";

const projectAPI = {
    fetchAll: async () => await Axios.get(`${window.API_URL}/project/get.php`),
    fetchByID: async data => await Axios.get(`${window.API_URL}/project/get.php?projectID=${data.projectID}`),
    fetchByTitle: async data => await Axios.get(`${window.API_URL}/project/get.php?titleID=${data.titleID}`),
    fetchAll: async () => await Axios.get(`${window.API_URL}/project/get.php`),
    uploadFile: async data => {
        let formData = new FormData();
        formData.append("file", data.file);
        formData.append("projectID", data.projectID);
        return await Axios.post(`${window.API_URL}/project/uploadFile.php`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    create: async data => await Axios.post(`${window.API_URL}/project/create.php`, {
        projectName: data.projectName,
        titleID:data.titleID,
        orderNumber:data.orderNumber
    }),
    trash: async data => await Axios.post(`${window.API_URL}/project/trash.php`, {
        projectID: data.projectID
    }),
    setName: async data => await Axios.post(`${window.API_URL}/project/setName.php`, {
        projectID:data.projectID,
        projectName:data.projectName,
        orderNumber: data.orderNumber
    }),
    setPO: async data => await Axios.post(`${window.API_URL}/project/setPO.php`, {
        projectID:data.projectID,
        orderNumber: data.orderNumber
    }),
    deletePO: async data => await Axios.post(`${window.API_URL}/project/deletePO.php`, {
        projectID:data.projectID,
    }),
};

export default projectAPI;